import { ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
export class BoardItem extends BaseEntity {
  @Prop({ type: RelatedEntity })
  entity: RelatedEntity
}
